import React from 'react';
import './Wave.css';

const WavingSVG = () => {
  return (
    <div className='hidden lg:flex ocean'>
      <div className='wave'></div>
    </div>
  )
};

export default WavingSVG;